import { Box, IconButton, Typography } from "@mui/material";
import {
  ArrowForward,
  RestaurantMenuOutlined as MenusIcon,
  AssessmentOutlined as FoodLogIcon,
} from "@mui/icons-material";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TabsRow from "../componenets/dashboard/coach/TabsRow";
import { v2 } from "../componenets/nutrition/v2/ui/v2Tokens";
import MenusListV2 from "../componenets/nutrition/v2/MenusListV2";
import FoodLogV2 from "../componenets/nutrition/v2/foodlog/FoodLogV2";

/**
 * Only what belongs to THIS trainee. Saved meals, menu templates and the food catalog are
 * company-wide and have their own pages under תזונה in the nav.
 */
const TABS = [
  { key: "menus", label: "תפריטים", Icon: MenusIcon },
  { key: "log", label: "יומן אכילה", Icon: FoodLogIcon },
];

const ClientNutritionV2Page = () => {
  const [tab, setTab] = useState("menus");
  const navigate = useNavigate();
  const { userId = "" } = useParams();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "18px" }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, flexWrap: "wrap" }}>
        <IconButton
          aria-label="חזרה ללקוח"
          onClick={() => navigate(`/app/clients/${userId}`)}
          sx={{ color: v2.ink3, p: 1, borderRadius: v2.rSm, "&:hover": { bgcolor: v2.lineSoft, color: v2.ink } }}
        >
          <ArrowForward />
        </IconButton>
        <Typography
          sx={{
            fontSize: { xs: "22px", md: "26px" },
            fontWeight: 600,
            color: v2.ink,
            lineHeight: 1.2,
            letterSpacing: "-0.3px",
          }}
        >
          תזונה
        </Typography>
        <Box sx={{ flex: 1 }} />

      </Box>

      <TabsRow value={tab} onChange={setTab} tabs={TABS} />

      <Box>
        {tab === "menus" && <MenusListV2 traineeId={userId} />}
        {tab === "log" && <FoodLogV2 traineeId={userId} />}
      </Box>
    </Box>
  );
};

export default ClientNutritionV2Page;
